import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';
import { map, from, switchMap, of } from 'rxjs';

export const clubAdminGuard: CanActivateFn = (route, state) => {
  const supabase = inject(SupabaseService);
  const router = inject(Router);
  const clubId = route.paramMap.get('clubId');

  // Resolve the user FIRST (getCurrentUser awaits auth.getUser() and lazily
  // loads the profile) so the guard never decides on the un-resolved profile$
  // seed — which would bounce legitimate club admins/owners to /dashboard on a
  // fresh navigation. Returning a UrlTree (not a subscription) also avoids the
  // open profile$ subscription re-firing on later emissions.
  return from(supabase.getCurrentUser()).pipe(
    switchMap((user) => {
      if (user && clubId) {
        return from(supabase.getUserClubRole(user.id, clubId)).pipe(
          map((role) => {
            // Mirror the backend authority (clubs.is_club_admin + RLS):
            // role IN ('admin','super_admin'). 'owner' is not a real enum value.
            if (role === 'admin' || role === 'super_admin') {
              return true;
            }
            return router.parseUrl('/dashboard');
          })
        );
      }
      return of(router.parseUrl('/dashboard'));
    })
  );
};
